import styled from "styled-components";

export const NoDataImg = styled.img`
  display: block;
  margin: auto;
`;
